import { useState } from "react";
import { Button, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import AutoComplete from "../../../../components/hookForms/autoComplete";
/* eslint-disable react-hooks/exhaustive-deps */
import File from "../../../../components/fileInputButton";
import { Loader } from "./styles";
import { getBase64 } from "../../../../utils/utils";
import serviceRebalanceMovimentacaoInstalacao from "../../../../services/serviceRebalanceMovimentacaoInstalacao";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    returnDate: (item: string[]) => void;
    onClose?: any;
}

export default function DialogUpload({ open, onClose, onSuccess, returnDate }: IDialogProps) {
    const [fileState, setFileState] = useState(null);
    const [selectedFileBase64, setSelectedFileBase64] = useState("");
    const [isDisable, setDisable] = useState(false);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            tipoCiclo: "",
        },
    });

    const tipoMovimentacaoOptions = [
        { label: "Comercial", value: "Comercial" },
        { label: "Pós venda", value: "Pós venda" },
        { label: "Financeiro", value: "Financeiro" },
        { label: "Pré-Faturamento", value: "Pré-Faturamento" },
    ];

    const onCancelNew = () => {
        reset();
        setFileState(null);
        onClose(true);
        setDisable(false);
    };

    const handleFileInput = (e: any) => {
        const extension = e.target.files[0].name.split(".").pop().toLowerCase();

        if (["csv"].includes(extension)) {
            setFileState(e.target.files[0]);

            getBase64(e.target.files[0]).then((result) => {
                setSelectedFileBase64(result);
            });
        } else {
            toast.error("O arquivo selecionado é inválido. É necessário anexar o arquivo no formato CSV!");
            setFileState(null);
        }
    };

    const validate = (values: any) => {
        if (!values.tipoCiclo) {
            toast.error("O campo TIPO deve ser informado");
            return false;
        }
        if (!values.fileBase64) {
            toast.error("Nenhum arquivo carregado, carregue um arquivo ou verifique se a extensão é válida");
            return false;
        }
        return true;
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        const treatedValues = {
            ...values,
            fileBase64: selectedFileBase64.replace("data:text/csv;base64,", ""),
            tipoArquivo:
                values.tipoCiclo === "Comercial"
                    ? "C"
                    : values.tipoCiclo === "Pós venda"
                    ? "P"
                    : values.tipoCiclo === "Financeiro"
                    ? "F"
                    : values.tipoCiclo === "Pré-Faturamento"
                    ? "M"
                    : "",
        };

        if (validate(treatedValues)) {
            serviceRebalanceMovimentacaoInstalacao
                .upload(treatedValues)
                .then((result) => {
                    if (result && result.data) {
                        // Se há erros, mostra no modal
                        if (result.data.errors && result.data.errors.length > 0) {
                            returnDate(result.data.errors);
                        } else {
                            // Sucesso no upload
                            toast.success("Upload realizado com sucesso!");
                            setFileState(null);
                            onClose(true);
                            onSuccess();
                            reset();
                        }
                    }
                })
                .catch((error) => {
                    toast.error("Erro no upload: " + (error.response?.data?.message || error.message));
                })
                .finally(() => {
                    setDisable(false);
                });
        } else {
            setDisable(false);
        }
    };

    return (
        <Dialog
            maxWidth="sm"
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
            PaperProps={{
                sx: {
                    width: '550px',
                    height: '400px'
                }
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Carregar
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelNew();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={0.5}>
                        <Grid item xs={12}>
                            {isDisable && (
                                <Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </Loader>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <AutoComplete
                                id="tipoCiclo"
                                name="tipoCiclo"
                                label="Tipo"
                                control={control}
                                error={errors}
                                options={tipoMovimentacaoOptions}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <File accept="text/csv" onChange={handleFileInput} selectedFile={fileState} />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "16px" }}>
                    <Button
                        id="cancelar"
                        onClick={() => {
                            onCancelNew();
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        id="carregar"
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Carregar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
